export default __webpack_public_path__ + "static/media/Portrait.f338becb.png";